<template>
  <div>
    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('system.alert') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">
                {{ $t('button.dismiss') }}
              </v-btn>
              <v-btn color="red accent-4" class="white--text" @click="deleteFromDatabase">
                {{ $t('button.confirm') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <v-dialog v-model="dialog" max-width="100%">
      <v-card>
        <v-card-title>
          <span class="headline" style="color: #4a4a4a">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="formValidado">
              <!-- Dados do template -->
              <v-card class="pa-4 mb-4" outlined>
                <v-card-title class="text-h6 pa-0 mb-3 d-flex align-center justify-space-between">
                  <span>{{ $t('contractTemplate.templateData') }}</span>
                  <v-switch
                    v-model="editedItem.ativo"
                    :label="$t('contractTemplate.active')"
                    :true-value="1"
                    :false-value="0"
                    class="mt-0 pt-0"
                    hide-details
                  ></v-switch>
                </v-card-title>
                <v-divider class="mb-3"></v-divider>
                <v-row>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field
                      v-model="editedItem.codigo"
                      :label="$t('contractTemplate.code')"
                      :rules="[(v) => (!!v && v.length <= 50) || $t('contractTemplate.codeRequired')]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="9">
                    <v-text-field
                      v-model="editedItem.nome"
                      :label="$t('contractTemplate.name')"
                      :rules="[(v) => (!!v && v.length <= 100) || $t('contractTemplate.nameRequired')]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="editedItem.descricao"
                      :label="$t('contractTemplate.description')"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>

              <!-- Os mesmos campos do formulário de contrato -->
              <v-card class="pa-4 mb-4" outlined>
                <v-card-title class="text-h6 pa-0 mb-3 d-flex align-center justify-space-between">
                  <span>{{ $t('contract.sections.generalData') }}</span>
                  <div class="d-flex align-center">
                    <v-switch
                      v-model="config.padrao"
                      :label="$t('contract.defaultForReports')"
                      :hint="$t('contract.defaultForReportsHint')"
                      persistent-hint
                      :true-value="1"
                      :false-value="0"
                      class="mt-0 pt-0 mr-4"
                    ></v-switch>
                    <v-switch
                      v-model="config.ativo"
                      :label="$t('contractTemplate.contractActive')"
                      :true-value="1"
                      :false-value="0"
                      class="mt-0 pt-0"
                      hide-details
                    ></v-switch>
                  </div>
                </v-card-title>
                <v-divider class="mb-3"></v-divider>
                <v-row>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field
                      v-model="config.cod_contrato"
                      :label="$t('contract.contractCode')"
                      :rules="[(v) => !v || v.length <= 15 || $t('contract.messages.codeRequired')]"
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-autocomplete
                      v-model="config.id_cliente"
                      :items="clientes"
                      :label="$t('contract.client')"
                      item-value="id_cliente"
                      item-text="nome_cliente"
                      clearable
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-autocomplete
                      v-model="config.id_empresa"
                      :items="empresasPermitidas"
                      :label="$t('contract.company')"
                      item-value="id_empresa"
                      item-text="razao_social"
                      clearable
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-autocomplete
                      v-model="config.id_unidades"
                      :items="unidades"
                      :label="$t('contract.unit')"
                      item-value="id_unidade"
                      item-text="descricao_unidade"
                      multiple
                      chips
                      deletable-chips
                      clearable
                      :hint="$t('contractV2.unitsHint')"
                      persistent-hint
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="config.descricao"
                      :label="$t('contract.description')"
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="config.observacoes"
                      :label="$t('contractTemplate.observations')"
                      clearable
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>

              <v-card class="pa-4 mb-4" outlined>
                <v-card-title class="text-h6 pa-0 mb-3">
                  {{ $t('contract.sections.validityClassification') }}
                </v-card-title>
                <v-divider class="mb-3"></v-divider>
                <v-row>
                  <v-col cols="12" sm="6" md="2">
                    <v-datetime-picker
                      :label="$t('contract.startValidity')"
                      v-model="dti"
                      :key="'dti-' + datePickerKey"
                      :time-picker-props="timeProps"
                      :text-field-props="textFieldProps"
                      time-format="HH:mm:ss"
                      date-format="dd/MM/yyyy"
                      :clear-text="$t('button.close')"
                    >
                      <template slot="dateIcon"><v-icon>mdi-calendar</v-icon></template>
                      <template slot="timeIcon"><v-icon>mdi-clock</v-icon></template>
                    </v-datetime-picker>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <v-datetime-picker
                      :label="$t('contract.endValidity')"
                      v-model="dtf"
                      :key="'dtf-' + datePickerKey"
                      :time-picker-props="timeProps"
                      :text-field-props="textFieldProps"
                      time-format="HH:mm:ss"
                      date-format="dd/MM/yyyy"
                      :clear-text="$t('button.close')"
                    >
                      <template slot="dateIcon"><v-icon>mdi-calendar</v-icon></template>
                      <template slot="timeIcon"><v-icon>mdi-clock</v-icon></template>
                    </v-datetime-picker>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <!-- Escolhido ao criar; na edição o template mantém o modelo da criação. -->
                    <v-select
                      v-model="config.modelo_mao_obra"
                      :items="modeloMaoObraItems"
                      :label="$t('contractV2.laborModel')"
                      :disabled="editedIndex !== -1"
                      :hint="$t('contractV2.laborModelHint')"
                      :persistent-hint="editedIndex !== -1"
                      item-value="value"
                      item-text="text"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <v-select
                      v-model="config.tipo_ciclo_pagamento"
                      :items="tipoCicloPagamentoItems"
                      :label="$t('contract.paymentCycle.type')"
                      item-value="value"
                      item-text="text"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="2" v-if="isCicloMensal">
                    <v-text-field
                      v-model.number="config.dia_ciclo_pagamento"
                      :label="$t('contract.paymentCycle.closingDay')"
                      type="number"
                      min="1"
                      max="28"
                      hide-spin-buttons
                      clearable
                      :hint="$t('contract.paymentCycle.closingDayHint')"
                      persistent-hint
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="2" v-if="isCicloDias">
                    <v-text-field
                      v-model.number="config.dias_ciclo_pagamento"
                      :label="$t('contract.paymentCycle.dayCount')"
                      type="number"
                      min="1"
                      max="366"
                      hide-spin-buttons
                      clearable
                      :hint="$t('contract.paymentCycle.dayCountHint')"
                      persistent-hint
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="2" v-if="isCicloQuinzenal || isCicloDias">
                    <v-text-field
                      v-model="config.dt_referencia_ciclo"
                      :label="$t('contract.paymentCycle.anchorDate')"
                      type="date"
                      clearable
                      :hint="isCicloDias ? $t('contract.paymentCycle.anchorDateHintDays') : $t('contract.paymentCycle.anchorDateHint')"
                      persistent-hint
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <v-text-field
                      v-model.number="config.prazo_pagamento_dias"
                      :label="$t('contract.conditions.paymentTermDays')"
                      type="number"
                      min="0"
                      hide-spin-buttons
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <v-text-field
                      v-model.number="config.idade_media_frota_anos"
                      :label="$t('contract.conditions.fleetAverageAge')"
                      type="number"
                      min="0"
                      hide-spin-buttons
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <v-text-field
                      v-model.number="config.distancia_max_viagem_m"
                      :label="$t('contract.conditions.maxTripDistance')"
                      type="number"
                      min="0"
                      step="1"
                      hide-spin-buttons
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <v-text-field
                      v-model.number="config.tempo_viagem_min"
                      :label="$t('contract.conditions.tripTime')"
                      type="number"
                      min="0"
                      hide-spin-buttons
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <v-text-field
                      v-model.number="config.valor_preposto"
                      :label="$t('contract.conditions.representativeValue')"
                      type="number"
                      min="0"
                      step="0.01"
                      prefix="$"
                      hide-spin-buttons
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <v-switch
                      v-model="config.time_atendimento"
                      :true-value="1"
                      :false-value="0"
                      :label="$t('contract.conditions.serviceTeam')"
                      class="mt-2"
                    ></v-switch>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <v-switch
                      v-model="config.linhas_intermunicipais"
                      :true-value="1"
                      :false-value="0"
                      :label="$t('contract.conditions.intercityLines')"
                      class="mt-2"
                    ></v-switch>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-autocomplete
                      v-model="config.cod_indicadores_reajuste"
                      :items="indicadoresReajusteItems"
                      :label="$t('contract.conditions.adjustmentIndicators')"
                      item-value="codigo"
                      item-text="rotulo"
                      :loading="carregandoIndicadores"
                      multiple
                      chips
                      small-chips
                      deletable-chips
                      clearable
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-autocomplete
                      v-model="config.id_tipos_veiculos"
                      :items="tiposVeiculos"
                      :label="$t('contractV2.vehicleTypes')"
                      item-value="id_tipo_veiculo"
                      item-text="descricao_tipo_veiculo"
                      multiple
                      chips
                      deletable-chips
                      clearable
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-card>

              <!-- Um card por tipo de veículo escolhido -->
              <contrato-tipo-veiculo-card
                v-for="idTipo in config.id_tipos_veiculos"
                :key="'tv-' + idTipo"
                :tipo-veiculo="tipoVeiculoPorId(idTipo)"
                :linhas="linhasPorTipo[idTipo] || []"
                :tarifas="tiposTarifas"
                :grandezas="calculosGrandeza"
                :calculos="calculosFiltro"
                :modelo-mao-obra="config.modelo_mao_obra"
                :faixas-mao-obra="(faixasPorTipo[idTipo] || {}).faixas_mao_obra || {}"
                @update:faixas="$set(faixasPorTipo, idTipo, $event)"
                @update:linhas="$set(linhasPorTipo, idTipo, $event)"
                @add-linha="adicionaLinhaTipo(idTipo)"
              />

              <div class="text--secondary text-caption">{{ $t('contractTemplate.rowsHint') }}</div>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" class="white--text" @click="close">
            {{ $t('button.cancel') }}
          </v-btn>
          <v-btn color="primary darken-1" class="white--text" :loading="salvando" @click="save">
            {{ $t('button.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <input ref="arquivoResposta" type="file" accept=".xlsx,.xls,.csv" style="display: none" @change="importarPlanilha" />
    <v-dialog :value="errosImportacao.length > 0" max-width="600" @input="errosImportacao = []">
      <v-card>
        <v-card-title>
          <span class="headline" style="color: #4a4a4a">{{ $t('contractTemplate.send.importErrors') }}</span>
        </v-card-title>
        <v-card-text>
          <div v-for="(erro, i) in errosImportacao" :key="i">
            <span v-if="erro.linha">{{ $t('contractTemplate.send.row', { row: erro.linha }) }}: </span>{{ erro.mensagem }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" class="white--text" @click="errosImportacao = []">{{ $t('button.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="respostaDialog" max-width="900" scrollable>
      <v-card v-if="resposta">
        <v-card-title>
          <span class="headline" style="color: #4a4a4a">
            {{ $t('contractTemplate.answer.title', { name: resposta.nome_template }) }}
          </span>
        </v-card-title>
        <v-card-subtitle>
          {{ resposta.nome_usuario_destino }} · {{ $t('receivedTemplate.status.' + resposta.status) }}
          <span v-if="resposta.dt_preenchimento"> · {{ $t('receivedTemplate.filledAt') }}: {{ new Date(resposta.dt_preenchimento).toLocaleString() }}</span>
        </v-card-subtitle>
        <v-card-text>
          <v-alert v-if="resposta.status !== 'PREENCHIDO'" type="info" dense text>{{ $t('contractTemplate.answer.partial') }}</v-alert>
          <v-data-table
            :headers="respostaHeaders"
            :items="resposta.itens_resposta || []"
            item-key="chave"
            group-by="tipo_veiculo"
            dense
            hide-default-footer
            :items-per-page="-1"
          >
            <template v-slot:item.valor_template="{ item }">{{ formataValorResposta(item.valor_template) }}</template>
            <template v-slot:item.valor_resposta="{ item }">
              <span :class="{ 'font-weight-bold': item.valor_resposta != null && item.valor_resposta !== item.valor_template }">
                {{ item.valor_resposta === undefined ? '' : formataValorResposta(item.valor_resposta) }}
              </span>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" class="white--text" @click="respostaDialog = false">{{ $t('button.close') }}</v-btn>
          <v-btn
            v-if="resposta.status === 'PREENCHIDO'"
            color="green darken-1"
            class="white--text"
            @click="respostaDialog = false; abrirContratoDaResposta(resposta)"
          >{{ $t('contractTemplate.answer.createContract') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="envioDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card v-if="envioTemplate">
        <v-toolbar dark color="primary">
          <v-btn icon dark :title="$t('button.close')" @click="envioDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t('contractTemplate.send.title', { name: envioTemplate.nome }) }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pt-4">
          <v-row align="center">
            <v-col cols="12" sm="9">
              <v-autocomplete
                v-model="usuarioDestino"
                :items="usuariosDestino"
                :loading="buscandoUsuarios"
                :search-input.sync="buscaUsuario"
                :label="$t('contractTemplate.send.user')"
                item-value="id_usuario"
                item-text="displayText"
                no-filter
                clearable
                hide-no-data
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-btn color="primary" block :disabled="!usuarioDestino" :loading="enviando" @click="enviarTemplate">
                {{ $t('contractTemplate.send.action') }}
              </v-btn>
            </v-col>
          </v-row>
          <div class="text-subtitle-2 mt-2 mb-1">{{ $t('contractTemplate.send.history') }}</div>
          <div v-if="canImportarPlanilha" class="text-caption mb-2">{{ $t('contractTemplate.send.importHint') }}</div>
          <v-data-table
            :headers="enviosHeaders"
            :items="envios"
            :loading="carregandoEnvios"
            dense
            hide-default-footer
            :items-per-page="-1"
          >
            <template v-slot:item.status="{ item }">
              {{ $t('receivedTemplate.status.' + item.status) }}
            </template>
            <template v-slot:item.dt_envio="{ item }">{{ item.dt_envio ? new Date(item.dt_envio).toLocaleString() : '' }}</template>
            <template v-slot:item.actions="{ item }">
              <envio-template-acoes
                :item="item"
                :can-ver="canVerResposta"
                :can-baixar="canBaixarPlanilha"
                :can-importar="canImportarPlanilha"
                :importando="importandoEnvio !== null"
                @ver="verResposta"
                @baixar="baixarPlanilha"
                @importar="escolherPlanilha"
              >
                <v-btn
                  v-if="item.status === 'PREENCHIDO'"
                  small
                  outlined
                  color="primary"
                  @click="abrirContratoDaResposta(item)"
                >
                  <v-icon left small>mdi-file-document-edit-outline</v-icon>{{ $t('contractTemplate.answer.createContract') }}
                </v-btn>
                <v-btn
                  v-if="['ENVIADO', 'EM_PREENCHIMENTO'].includes(item.status)"
                  small
                  outlined
                  color="red"
                  @click="cancelarEnvio(item)"
                >
                  <v-icon left small>mdi-cancel</v-icon>{{ $t('contractTemplate.send.cancelShort') }}
                </v-btn>
              </envio-template-acoes>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-container max-width="100%" style="margin-top: 2%">
      <merus-data-table
        :headers="headers"
        :items="templatesExibidos"
        :loading="loading"
        :loading-text="$t('contractTemplate.loading')"
        @update:displayedItems="displayedItemsForExport = $event"
        cod-tabela="CONTRATOTEMPLATES"
        @update:headers="headers = $event"
      >
        <template v-slot:toolbar>
          <cadastro-toolbar
            :title="$t('contractTemplate.title')"
            :token="token"
            :items="displayedItemsForExport !== null ? displayedItemsForExport : templatesExibidos"
            :csv-title="$t('contractTemplate.title')"
            :csv-headers="headers"
            :pdf-title="$t('contractTemplate.title')"
            :pdf-headers="headers"
            :pdf-filename="$t('contractTemplate.title')"
            hide-search
          >
            <template v-slot:add v-if="canInsert">
              <v-btn color="primary" dark small class="mb-2" fab @click="openNewItem" v-if="canInsert">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
          </cadastro-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon
            small
            class="mr-2"
            color="primary"
            @click="abrirEnvio(item)"
            :disabled="!canSend || item.ativo == 0"
          >mdi-send</v-icon>
          <v-icon small class="mr-2" color="green" @click="editItem(item)" :disabled="!canEdit">
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="mr-2"
            color="red"
            @click="deleteItem(item)"
            :disabled="item.ativo == 0 || !canDelete"
          >mdi-delete</v-icon>
        </template>
      </merus-data-table>
    </v-container>
  </div>
</template>

<script>
import apiController from '@/utils/apiController';
import EventBus from '@/utils/eventBus';
import MerusDataTable from './Tables/MerusDataTable.vue';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import ContratoTipoVeiculoCard from './Contratos/ContratoTipoVeiculoCard.vue';
import EnvioTemplateAcoes from './Contratos/EnvioTemplateAcoes.vue';
import translateDbField from '@/utils/translateDbField';
import { aceitaComoFiltroLinha, aceitaComoGrandezaLinha } from '../utils/subsidioFinalidadeCalculo';

/**
 * Cadastro de templates de contrato de subsídio.
 *
 * O template tem os mesmos campos do formulário de contrato (código, cliente,
 * empresa, unidades, descrição, observações, vigência, ciclo de pagamento,
 * ativo, padrão, tipos de veículo e as linhas de valor de cada tipo, como no contrato). Empresa,
 * cliente, unidades e tipos de veículo entram por id; tarifa e cálculos das
 * linhas, pelo CÓDIGO, para valer em qualquer banco. As linhas são editadas
 * pelos mesmos componentes da tela de contratos, que trabalham com ids; a
 * conversão código ↔ id acontece ao abrir e ao salvar. Código que o catálogo
 * deste banco não conhece é preservado, para editar o template aqui não apagar
 * o que só existe em outro ambiente.
 */
export default {
  name: 'CRUDContratoTemplates',
  components: { MerusDataTable, CadastroToolbar, ContratoTipoVeiculoCard, EnvioTemplateAcoes },
  data: () => ({
    headers: [
      { text: 'Código', value: 'codigo' },
      { text: 'Nome', value: 'nome' },
      { text: 'Descrição', value: 'descricao' },
      { text: 'Linhas', value: 'qtd_linhas' },
      { text: 'Ativo', value: 'ativo_extenso' },
    ],
    displayedItemsForExport: null,
    token: null,
    loading: false,
    salvando: false,
    formValidado: true,
    dialog: false,
    confirmDialog: false,
    mensagemdialog: '',

    templates: [],
    clientes: [],
    unidades: [],
    tiposVeiculos: [],
    tiposTarifas: [],
    calculosGrandeza: [],
    calculosFiltro: [],
    recursos: [],
    empresasPermitidas: [],
    indicadoresReajuste: [],
    carregandoIndicadores: false,

    canInsert: false,
    canEdit: false,
    canDelete: false,
    canSend: false,
    canBaixarPlanilha: false,
    canVerResposta: false,
    // Resposta de um envio (valores do template x respondidos).
    respostaDialog: false,
    resposta: null,
    canImportarPlanilha: false,

    // Envio do template a um usuário cliente.
    envioDialog: false,
    envioTemplate: null,
    envios: [],
    carregandoEnvios: false,
    usuarioDestino: null,
    usuariosDestino: [],
    buscaUsuario: '',
    buscandoUsuarios: false,
    enviando: false,
    buscaUsuarioTimer: null,
    // Importação da planilha devolvida pelo cliente.
    envioImportacao: null,
    importandoEnvio: null,
    errosImportacao: [],

    dti: null,
    dtf: null,
    datePickerKey: 0,
    textFieldProps: { prependInnerIcon: 'mdi-calendar' },
    timeProps: { useSeconds: true },

    editedIndex: -1,
    editedItem: null,
    deletedItem: null,
    // Linhas de valor de cada tipo de veículo, como no contrato.
    linhasPorTipo: {},
    // Preços das faixas de mão de obra de cada tipo (modelo FAIXAS).
    faixasPorTipo: {},
  }),
  computed: {
    respostaHeaders() {
      return [
        { text: this.$t('contractTemplate.answer.item'), value: 'descricao', sortable: false },
        { text: this.$t('contractTemplate.answer.templateValue'), value: 'valor_template', sortable: false, align: 'end' },
        { text: this.$t('contractTemplate.answer.answeredValue'), value: 'valor_resposta', sortable: false, align: 'end' },
      ];
    },
    enviosHeaders() {
      return [
        { text: this.$t('contractTemplate.send.user'), value: 'nome_usuario_destino', sortable: false },
        { text: this.$t('receivedTemplate.statusLabel'), value: 'status', sortable: false },
        { text: this.$t('receivedTemplate.sentAt'), value: 'dt_envio', sortable: false },
        { text: '', value: 'actions', sortable: false },
      ];
    },
    modeloMaoObraItems() {
      return [
        { value: 'PADRAO', text: this.$t('contractV2.laborModelDefault') },
        { value: 'FAIXAS', text: this.$t('contractV2.laborModelRanges') },
      ];
    },
    // Inativo só aparece habilitado se já está entre os escolhidos.
    indicadoresReajusteItems() {
      const escolhidos = this.config.cod_indicadores_reajuste || [];
      const itens = this.indicadoresReajuste.map((i) => ({
        ...i,
        rotulo: i.codigo + ' — ' + i.nome,
        disabled: i.ativo != 1 && !escolhidos.includes(i.codigo),
      }));
      // Código que este banco não conhece fica na lista, para não se perder ao salvar.
      escolhidos.forEach((cod) => {
        if (!itens.some((i) => i.codigo === cod)) itens.push({ codigo: cod, rotulo: cod, disabled: false });
      });
      return itens;
    },
    config() {
      return this.editedItem.config;
    },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t('contractTemplate.newTemplate')
        : this.$t('contractTemplate.editTemplate');
    },
    templatesExibidos() {
      return this.templates.map((t) => ({
        ...t,
        ativo_extenso: t.ativo == 1 ? this.$t('system.yes') : this.$t('system.no'),
      }));
    },
    isCicloMensal() {
      return (this.config.tipo_ciclo_pagamento || 'MENSAL') === 'MENSAL';
    },
    isCicloQuinzenal() {
      return this.config.tipo_ciclo_pagamento === 'QUINZENAL';
    },
    isCicloDias() {
      return this.config.tipo_ciclo_pagamento === 'DIAS';
    },
    tipoCicloPagamentoItems() {
      return [
        { value: 'MENSAL', text: this.$t('contract.paymentCycle.monthly') },
        { value: 'QUINZENAL', text: this.$t('contract.paymentCycle.biweekly') },
        { value: 'DIAS', text: this.$t('contract.paymentCycle.customDays') },
      ];
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.token = sessionStorage.getItem('api');
    this.editedItem = this.itemVazio();
    this.deletedItem = this.itemVazio();
    this._uid_linha = 0;
    this.populaRecursos();
    this.populaTemplates();
    this.populaCatalogo();
  },
  watch: {
    // Seletor de usuário sob demanda: busca no servidor conforme digita.
    buscaUsuario(texto) {
      clearTimeout(this.buscaUsuarioTimer);
      if (this.usuarioDestino && this.usuariosDestino.some((u) => u.displayText === texto)) return;
      this.buscaUsuarioTimer = setTimeout(() => this.buscaUsuarios(texto), 300);
    },
  },
  methods: {
    async buscaUsuarios(texto) {
      this.buscandoUsuarios = true;
      try {
        const response = await apiController.request(apiController.endpoints.getUsuarioslazy, {
          data: { page: 1, pageSize: 20, search: texto || '', excluirPassageiros: true },
          silent: true,
        });
        const encontrados = ((response.data && response.data.items) || []).map((u) => ({
          ...u,
          displayText: `${u.nome_usuario} (${u.login})`,
        }));
        const atual = this.usuariosDestino.find((u) => u.id_usuario === this.usuarioDestino);
        this.usuariosDestino = atual && !encontrados.some((u) => u.id_usuario === atual.id_usuario)
          ? [atual].concat(encontrados)
          : encontrados;
      } catch (e) {
        EventBus.$emit('show-error', { error: e });
      } finally {
        this.buscandoUsuarios = false;
      }
    },
    // A tela de contratos abre um contrato novo já preenchido com a resposta.
    abrirContratoDaResposta(item) {
      this.envioDialog = false;
      this.$router.push({ path: '/contratos-subsidio', query: { resposta: String(item.id_envio) } });
    },
    async verResposta(item) {
      try {
        const response = await apiController.request(apiController.endpoints.subsidioGetEnviotemplatecontratorevisao, {
          params: { id: item.id_envio },
          silent: true,
        });
        const resposta = response.data;
        (resposta.itens_resposta || []).forEach((i) => { i.chave = i.id_tipo_veiculo + '|' + i.campo; });
        this.resposta = resposta;
        this.respostaDialog = true;
      } catch (e) {
        EventBus.$emit('show-error', { error: e });
      }
    },
    formataValorResposta(v) {
      if (v == null || v === '') return '';
      return Number(v).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 4 });
    },
    async carregaEnvios() {
      this.carregandoEnvios = true;
      try {
        const response = await apiController.request(apiController.endpoints.subsidioGetEnviostemplatecontrato, {
          params: { id: this.envioTemplate.id_template },
          silent: true,
        });
        this.envios = response.data || [];
      } catch (e) {
        EventBus.$emit('show-error', { error: e });
      } finally {
        this.carregandoEnvios = false;
      }
    },
    abrirEnvio(item) {
      this.envioTemplate = item;
      this.usuarioDestino = null;
      this.usuariosDestino = [];
      this.buscaUsuario = '';
      this.envios = [];
      this.errosImportacao = [];
      this.envioDialog = true;
      this.carregaEnvios();
      this.buscaUsuarios('');
    },
    async enviarTemplate() {
      this.enviando = true;
      try {
        const response = await apiController.request(apiController.endpoints.subsidioInsertEnviotemplatecontrato, {
          data: { id_template: this.envioTemplate.id_template, id_usuario_destino: this.usuarioDestino },
          silent: true,
        });
        const emailOk = response.data && response.data.email_enfileirado;
        EventBus.$emit('show-alert', {
          mensagem: this.$t(emailOk ? 'contractTemplate.send.sent' : 'contractTemplate.send.sentNoEmail'),
          tipo: emailOk ? 'success' : 'warning',
        });
        this.usuarioDestino = null;
        this.carregaEnvios();
      } catch (e) {
        EventBus.$emit('show-error', { error: e });
      } finally {
        this.enviando = false;
      }
    },
    async baixarPlanilha(item, formato) {
      try {
        const response = await apiController.request(apiController.endpoints.subsidioGetPlanilhaenviotemplatecontrato, {
          params: { id: item.id_envio },
          query: { formato },
          config: { responseType: 'blob' },
          silent: true,
        });
        const url = URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        const codigo = item.codigo_template || (this.envioTemplate && this.envioTemplate.codigo) || item.id_template;
        link.download = `template_${codigo}_envio_${item.id_envio}.${formato}`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
      } catch (e) {
        EventBus.$emit('show-error', { error: e });
      }
    },
    escolherPlanilha(item) {
      this.envioImportacao = item;
      this.$refs.arquivoResposta.value = '';
      this.$refs.arquivoResposta.click();
    },
    async importarPlanilha(event) {
      const arquivo = event.target.files && event.target.files[0];
      if (!arquivo || !this.envioImportacao) return;
      const fd = new FormData();
      fd.append('id_envio', String(this.envioImportacao.id_envio));
      fd.append('file', arquivo, arquivo.name);
      this.importandoEnvio = this.envioImportacao.id_envio;
      this.errosImportacao = [];
      try {
        await apiController.request(apiController.endpoints.subsidioImportarplanilhaenviotemplatecontrato, {
          data: fd,
          silent: true,
        });
        EventBus.$emit('show-alert', { mensagem: this.$t('contractTemplate.send.imported'), tipo: 'success' });
        this.carregaEnvios();
      } catch (e) {
        const erros = e && e.response && e.response.data && e.response.data.erros;
        if (Array.isArray(erros) && erros.length) this.errosImportacao = erros;
        else EventBus.$emit('show-error', { error: e });
      } finally {
        this.importandoEnvio = null;
        this.envioImportacao = null;
      }
    },
    async cancelarEnvio(item) {
      try {
        await apiController.request(apiController.endpoints.subsidioCancelarenviotemplatecontrato, {
          data: { id_envio: item.id_envio },
          silent: true,
        });
        this.carregaEnvios();
      } catch (e) {
        EventBus.$emit('show-error', { error: e });
      }
    },
    itemVazio() {
      return {
        id_template: null,
        codigo: null,
        nome: null,
        descricao: null,
        ativo: 1,
        config: {
          cod_contrato: null,
          descricao: null,
          observacoes: null,
          id_empresa: null,
          id_cliente: null,
          id_unidades: [],
          dt_inicio: null,
          dt_fim: null,
          ativo: 1,
          padrao: 0,
          modelo_mao_obra: 'PADRAO',
          tipo_ciclo_pagamento: 'MENSAL',
          dia_ciclo_pagamento: null,
          dias_ciclo_pagamento: null,
          dt_referencia_ciclo: null,
          prazo_pagamento_dias: null,
          idade_media_frota_anos: null,
          distancia_max_viagem_m: null,
          tempo_viagem_min: null,
          time_atendimento: 0,
          linhas_intermunicipais: 0,
          valor_preposto: null,
          cod_indicadores_reajuste: [],
          id_tipos_veiculos: [],
        },
      };
    },
    carregaLista(endpoint, aplica) {
      return apiController
        .request(endpoint, {
          onSuccess: (response) => {
            aplica(Array.isArray(response.data) ? response.data : []);
          },
        })
        .catch(() => {});
    },
    populaTemplates() {
      this.loading = true;
      return this.carregaLista(apiController.endpoints.subsidioGetallContratotemplates, (lista) => {
        this.templates = lista;
      }).finally(() => {
        this.loading = false;
      });
    },
    populaCatalogo() {
      this.carregaLista(apiController.endpoints.getallTipostarifas, (lista) => {
        this.tiposTarifas = lista;
      });
      this.carregaLista(apiController.endpoints.subsidioMotorCalculos, (lista) => {
        this.calculosFiltro = lista.filter((c) => aceitaComoFiltroLinha(c.finalidade));
        this.calculosGrandeza = lista.filter((c) => aceitaComoGrandezaLinha(c.finalidade));
      });
      this.carregaLista(apiController.endpoints.getallClientes, (lista) => {
        this.clientes = lista.filter((c) => c.ativo === 1 || c.ativo === true || c.ativo == null);
      });
      this.carregaLista(apiController.endpoints.getallUnidades, (lista) => {
        this.unidades = lista.filter((u) => u.ativa == 1);
      });
    },
    // Catálogo pequeno: uma página só, com os inativos (o contrato pode já
    // estar associado a um indicador desativado depois).
    populaIndicadoresReajuste() {
      this.carregandoIndicadores = true;
      return apiController.request(apiController.endpoints.subsidioGetallIndicadoresreajuste, {
        data: { page: 1, rowsPerPage: 1000, total: 'true', sortBy: 'nome', sortDesc: 'false' },
        onSuccess: (response) => {
          const data = response.data;
          this.indicadoresReajuste = Array.isArray(data && data.items) ? data.items : [];
        },
      })
        .catch(() => {})
        .finally(() => {
          this.carregandoIndicadores = false;
        });
    },
    populaTiposVeiculos() {
      this.carregaLista(apiController.endpoints.getallTiposveiculos, (lista) => {
        this.tiposVeiculos = lista.map((tipoVeiculo) => ({
          ...tipoVeiculo,
          descricao_tipo_veiculo: translateDbField(
            tipoVeiculo.translation_key,
            tipoVeiculo.descricao_tipo_veiculo,
          ),
        }));
      });
    },
    populaRecursos() {
      const aplica = (response, superadmin) => {
        this.recursos = response.data || [];
        const tem = (rota) => this.recursos.some((r) => r.rota === rota);
        this.canEdit = superadmin || tem('/api/v1.0/subsidio/updatecontratotemplate');
        this.canInsert = superadmin || tem('/api/v1.0/subsidio/insertcontratotemplate');
        this.canDelete = superadmin || tem('/api/v1.0/subsidio/deletecontratotemplate');
        this.canSend = superadmin || tem('/api/v1.0/subsidio/insertenviotemplatecontrato');
        this.canVerResposta = superadmin || tem('/api/v1.0/subsidio/getenviotemplatecontratorevisao');
        this.canBaixarPlanilha = superadmin || tem('/api/v1.0/subsidio/getplanilhaenviotemplatecontrato');
        this.canImportarPlanilha = superadmin || tem('/api/v1.0/subsidio/importarplanilhaenviotemplatecontrato');
        this.empresasPermitidas = this.recursos
          .filter((r) => r.id_empresa)
          .map((rec) => ({ id_empresa: rec.id_empresa, razao_social: rec.razao_social }));
        // Os tipos de veículo dependem das empresas permitidas, que saem daqui.
        this.populaTiposVeiculos();
        if (superadmin || tem('/api/v1.0/subsidio/getallindicadoresreajuste')) {
          this.populaIndicadoresReajuste();
        }
      };
      const superadmin = this.user.is_superadmin === 1;
      const endpoint = superadmin
        ? apiController.endpoints.getallRecursos
        : apiController.endpoints.getRecursosusuario;
      const opcoes = { onSuccess: (response) => aplica(response, superadmin) };
      if (!superadmin) opcoes.params = { id: this.user.id_usuario };
      return apiController.request(endpoint, opcoes).catch(() => {});
    },
    tipoVeiculoPorId(id) {
      return (
        this.tiposVeiculos.find((t) => Number(t.id_tipo_veiculo) === Number(id)) || {
          id_tipo_veiculo: id,
          descricao_tipo_veiculo: null,
        }
      );
    },

    // ----- linhas: código ↔ id --------------------------------------------

    proximoUid() {
      this._uid_linha += 1;
      return this._uid_linha;
    },
    linhaVazia(ordem) {
      return {
        uid: this.proximoUid(),
        id_tarifa: null,
        valor: null,
        id_calculo_grandeza: null,
        id_calculo_filtro: null,
        ordem,
      };
    },
    adicionaLinhaTipo(idTipo) {
      const atuais = this.linhasPorTipo[idTipo] || [];
      this.$set(this.linhasPorTipo, idTipo, atuais.concat([this.linhaVazia(atuais.length)]));
    },
    idPorCodigo(lista, campoCodigo, campoId, codigo) {
      if (!codigo) return null;
      const item = lista.find((x) => x[campoCodigo] === codigo);
      return item ? item[campoId] : null;
    },
    linhasDoConfig(linhas) {
      return (linhas || []).map((l, idx) => ({
        uid: this.proximoUid(),
        id_tarifa: this.idPorCodigo(this.tiposTarifas, 'cod_tarifa', 'id_tarifa', l.cod_tarifa),
        valor: l.valor == null ? null : Number(l.valor),
        id_calculo_grandeza: this.idPorCodigo(
          this.calculosGrandeza, 'codigo', 'id_calculo', l.calculo_grandeza,
        ),
        id_calculo_filtro: this.idPorCodigo(
          this.calculosFiltro, 'codigo', 'id_calculo', l.calculo_filtro,
        ),
        ordem: idx,
        // Códigos que este banco não conhece: guardados para o salvar devolver.
        _cod_tarifa: l.cod_tarifa,
        _calculo_grandeza: l.calculo_grandeza || null,
        _calculo_filtro: l.calculo_filtro || null,
      }));
    },
    codigoPorId(lista, campoCodigo, campoId, id, original) {
      if (id == null) return original || null;
      const item = lista.find((x) => Number(x[campoId]) === Number(id));
      return item ? item[campoCodigo] : original || null;
    },
    configDasLinhas(linhas) {
      return (linhas || [])
        .map((l) => ({
          cod_tarifa: this.codigoPorId(this.tiposTarifas, 'cod_tarifa', 'id_tarifa', l.id_tarifa, l._cod_tarifa),
          valor: l.valor == null || l.valor === '' ? null : Number(l.valor),
          calculo_grandeza: this.codigoPorId(
            this.calculosGrandeza, 'codigo', 'id_calculo', l.id_calculo_grandeza, l._calculo_grandeza,
          ),
          calculo_filtro: this.codigoPorId(
            this.calculosFiltro, 'codigo', 'id_calculo', l.id_calculo_filtro, l._calculo_filtro,
          ),
        }))
        .filter((l) => !!l.cod_tarifa);
    },

    // ----- datas ------------------------------------------------------------

    // O seletor entrega Date; o template guarda o texto `dd/MM/yyyy HH:mm:ss`,
    // que é o que o seletor do contrato volta a aceitar.
    dataParaTexto(valor) {
      if (!valor) return null;
      if (valor instanceof Date) return valor.toLocaleString('pt-BR').replace(',', '');
      return String(valor);
    },

    // ----- abertura / fechamento ------------------------------------------

    resetaEdicao() {
      this.editedItem = this.itemVazio();
      this.editedIndex = -1;
      this.linhasPorTipo = {};
      this.faixasPorTipo = {};
      this.dti = null;
      this.dtf = null;
      this.datePickerKey += 1;
    },
    openNewItem() {
      this.resetaEdicao();
      this.dialog = true;
    },
    async editItem(item) {
      try {
        const response = await apiController.request(
          apiController.endpoints.subsidioGetContratotemplate,
          { params: { id: item.id_template }, silent: true },
        );
        const t = response.data;
        const cfg = t.config || {};
        this.resetaEdicao();
        this.editedIndex = this.templates.findIndex((x) => x.id_template === t.id_template);
        this.editedItem = {
          id_template: t.id_template,
          codigo: t.codigo,
          nome: t.nome,
          descricao: t.descricao,
          ativo: t.ativo == 1 ? 1 : 0,
          config: Object.assign(this.itemVazio().config, cfg, {
            id_unidades: cfg.id_unidades || [],
            id_tipos_veiculos: cfg.id_tipos_veiculos || [],
            // `cod_indicador_reajuste` (um só) é de uma versão anterior do template.
            cod_indicadores_reajuste: Array.from(new Set(
              (cfg.cod_indicadores_reajuste || []).concat(cfg.cod_indicador_reajuste ? [cfg.cod_indicador_reajuste] : []),
            )),
          }),
        };
        this.dti = cfg.dt_inicio || null;
        this.dtf = cfg.dt_fim || null;
        const porTipo = {};
        const faixas = {};
        (cfg.tipos_veiculo || []).forEach((tv) => {
          porTipo[tv.id_tipo_veiculo] = this.linhasDoConfig(tv.linhas);
          faixas[tv.id_tipo_veiculo] = { faixas_mao_obra: tv.faixas_mao_obra || {} };
        });
        this.linhasPorTipo = porTipo;
        this.faixasPorTipo = faixas;
        this.dialog = true;
      } catch (e) {
        EventBus.$emit('show-error', { error: e });
      }
    },
    close() {
      this.dialog = false;
      if (this.$refs.form && typeof this.$refs.form.resetValidation === 'function') {
        this.$refs.form.resetValidation();
      }
      this.$nextTick(() => this.resetaEdicao());
    },

    // ----- gravação ---------------------------------------------------------

    // Só os tipos de veículo ainda escolhidos guardam linhas e faixas próprias.
    tiposParaSalvar() {
      return (this.config.id_tipos_veiculos || [])
        .filter((id) => this.linhasPorTipo[id] || this.faixasPorTipo[id])
        .map((id) => ({
          id_tipo_veiculo: id,
          // Só contrato FAIXAS guarda os preços das faixas.
          ...(this.config.modelo_mao_obra === 'FAIXAS' ? this.faixasPorTipo[id] || {} : {}),
          linhas: this.configDasLinhas(this.linhasPorTipo[id] || []),
        }));
    },
    validaLinhas() {
      for (const tipo of this.tiposParaSalvar()) {
        const usadas = new Set();
        for (const l of tipo.linhas) {
          if (usadas.has(l.cod_tarifa)) return this.$t('contractTemplate.duplicateTariff');
          usadas.add(l.cod_tarifa);
        }
      }
      return null;
    },
    async save() {
      this.$refs.form.validate();
      if (!this.formValidado) return;
      const erroLinhas = this.validaLinhas();
      if (erroLinhas) {
        EventBus.$emit('show-alert', { mensagem: erroLinhas, tipo: 'error' });
        return;
      }

      this.salvando = true;
      const criando = this.editedIndex === -1;
      try {
        const endpoint = criando
          ? apiController.endpoints.subsidioInsertContratotemplate
          : apiController.endpoints.subsidioUpdateContratotemplate;
        const response = await apiController.request(endpoint, {
          data: {
            id_template: this.editedItem.id_template,
            codigo: this.editedItem.codigo,
            nome: this.editedItem.nome,
            descricao: this.editedItem.descricao,
            ativo: this.editedItem.ativo,
            config: Object.assign({}, this.config, {
              dt_inicio: this.dataParaTexto(this.dti),
              dt_fim: this.dataParaTexto(this.dtf),
              tipos_veiculo: this.tiposParaSalvar(),
            }),
          },
          silent: true,
        });
        if (response.data && response.data.erro) {
          EventBus.$emit('show-alert', { mensagem: response.data.mensagem, tipo: 'error' });
          return;
        }
        EventBus.$emit('show-alert', { mensagem: this.$t('contractTemplate.saved'), tipo: 'success' });
        this.close();
        this.populaTemplates();
      } catch (e) {
        EventBus.$emit('show-error', { error: e });
      } finally {
        this.salvando = false;
      }
    },

    // ----- exclusão (desativa) ----------------------------------------------

    deleteItem(item) {
      this.deletedItem = Object.assign({}, item);
      this.mensagemdialog = this.$t('contractTemplate.confirmDelete', { code: item.codigo });
      this.confirmDialog = true;
    },
    deleteFromDatabase() {
      apiController
        .request(apiController.endpoints.subsidioDeleteContratotemplate, {
          data: { id_template: this.deletedItem.id_template },
          onSuccess: () => {
            this.confirmDialog = false;
            EventBus.$emit('show-alert', {
              mensagem: this.$t('contractTemplate.deleted'),
              tipo: 'success',
            });
            this.populaTemplates();
          },
          onError: () => {
            this.confirmDialog = false;
          },
        })
        .catch(() => {});
    },
  },
};
</script>
